module.exports = __webpack_public_path__ + "img/still (27).ec21e205.jpg";